var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732773 1.06207C1.7098 0.109531 3.29388 0.109532 4.27091 1.06208L20.2672 16.6575C21.2442 17.61 21.2442 19.1544 20.2672 20.1069C19.2902 21.0595 17.7061 21.0595 16.7291 20.1069L0.732773 4.51154C-0.244258 3.559 -0.244258 2.01462 0.732773 1.06207Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2673 1.06206C21.2443 2.01461 21.2443 3.55898 20.2673 4.51153L4.271 20.1069C3.29397 21.0595 1.70989 21.0595 0.732857 20.1069C-0.244173 19.1544 -0.244173 17.61 0.732858 16.6575L16.7292 1.06206C17.7062 0.10952 19.2903 0.10952 20.2673 1.06206Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c9571d95ed59ec7d12ee54b087b7b308.svg";
export { ForwardRef as ReactComponent };